import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress } from '@mui/material';

interface ButtonProps extends MuiButtonProps {
  isPending?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ isPending, children, ...props }, ref) => (
  <MuiButton ref={ref} {...props} disabled={isPending}>
    {isPending ? <CircularProgress size={20} color='inherit' /> : children}
  </MuiButton>
));

export default Button;
